import type { IRItemInfo } from '../types';

import { EDimensionKey } from '../types';

export const DIMENSION_INFO: IRItemInfo = {
  [EDimensionKey.TIME]: {
    title: 'Time',
    content: 'Timestamp the data was recorded',
    helps: [],
  },
  [EDimensionKey.VERSION]: {
    title: 'Version',
    content: 'Template version in an experiment that resulted in the order',
    helps: [],
  },
  [EDimensionKey.EXPERIMENT_ID]: {
    title: 'Experiment name',
    content: 'Experiments that resulted in the order',
    helps: [],
  },
  [EDimensionKey.TRAFFIC_SOURCE]: {
    title: 'Traffic source',
    content: 'Where your customers came from',
    helps: [],
  },
  [EDimensionKey.VISITOR]: {
    title: 'Visitor',
    content: 'Target visitors who placed the order',
    helps: [],
  },
  [EDimensionKey.DEVICE]: {
    title: 'Device',
    content: 'Device customers used to place the order',
    helps: [],
  },
};
